import { render, staticRenderFns } from "./jobfairPost.vue?vue&type=template&id=b652d5c8&scoped=true"
import script from "./jobfairPost.vue?vue&type=script&lang=js"
export * from "./jobfairPost.vue?vue&type=script&lang=js"
import style0 from "./jobfairPost.vue?vue&type=style&index=0&id=b652d5c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b652d5c8",
  null
  
)

export default component.exports